import dayjs from 'dayjs';
import { FILTER_TYPE } from './workQueue.constant';

export const defaultActivityDateModalState = {
    show: false,
    onHide: () => {},
    activity: {
        id: '',
        dateDue: null,
        typeLabel: '',
        patientId: '',
    },
};

export const defaultActivityNoteModalState = {
    show: false,
    onHide: () => {},
    activity: {
        id: '',
        typeLabel: '',
        name: '',
    },
    patient: {
        firstName: '',
        lastName: '',
    },
};

export const defaultWorkQueueState = {
    filterParams: {
        search: {},
        dateEnd: new Date(dayjs().endOf('isoWeek')),
        dateStart: new Date(dayjs().startOf('isoWeek')),
        type: 'this_week',
        branches: [],
        highRisk: false,
        onlyMine: false,
        allTypes: false,
        categories: [],
        allBranches: true,
        assignedToMe: false,
        filters: [],
        predictiveModelRisk: false,
        allCategories: true,
        excludeBranches: false,
        excludeCategories: false,
        excludeActivityTypes: false,
        patientLabels: [],
        excludePatientLabels: false,
        page: 1,
        count: 25,
        sorting: {
            patient_name: 'asc',
        },
    },
    mobileAnswersFilterParams: {
        search: {},
        page: 1,
        count: 10,
        sorting: {
            patient_name: 'asc',
        },
    },
    pendingFilterParams: {
        dateRangeFilterOption: { value: 'this_week', name: 'This Week' },
        therapeuticCategoryOptions: [{ id: '', option: '' }],
        therapeuticCategoryType: { value: 'is', name: 'is' },
        branchOptions: [{ id: '', option: '' }],
        branchType: { value: 'is', name: 'is' },
        activityFilterOptions: [],
        activityFilterType: { value: 'is', name: 'is' },
        highRisk: false,
        onlyMine: false,
        allTypes: false,
        predictiveModelRisk: false,
        dateStart: new Date(dayjs().subtract(1, 'year').subtract(30, 'day')),
        dateEnd: new Date(dayjs().add(1, 'year').add(30, 'day')),
    },
    result: {
        savedFilterResult: [],
        activityCountResult: {},
        workQueueTableHeaders: {},
        workQueueActivityCount: 0,
        workQueueResult: [],
        unassignedPatientResult: [],
        unassignedMedicationResult: [],
    },
    isLoading: true,
    modalState: {
        activityDateModal: defaultActivityDateModalState,
        activityNoteModal: defaultActivityNoteModalState,
    },
    selectedRows: {},
    activeSavedFilter: null,
    filterType: FILTER_TYPE.WORK_QUEUE,
    allBranchesList: [],
    allCategoriesList: [],
    allActivityTypesList: [],
    allCustomOptionsList: [],
    allPatientLabelsList: [],
};

export const getDefaultWorkQueueState = () => ({
    filterParams: {
        search: {},
        dateEnd: new Date(dayjs().endOf('isoWeek')),
        dateStart: new Date(dayjs().startOf('isoWeek')),
        type: 'this_week',
        branches: [],
        highRisk: false,
        onlyMine: false,
        allTypes: false,
        categories: [],
        allBranches: true,
        assignedToMe: false,
        filters: [],
        predictiveModelRisk: false,
        allCategories: true,
        excludeBranches: false,
        excludeCategories: false,
        excludeActivityTypes: false,
        patientLabels: [],
        excludePatientLabels: false,
        page: 1,
        count: 25,
        sorting: {
            patient_name: 'asc',
        },
    },
    mobileAnswersFilterParams: {
        search: {},
        page: 1,
        count: 10,
        sorting: {
            patient_name: 'asc',
        },
    },
    pendingFilterParams: {
        dateRangeFilterOption: { value: 'this_week', name: 'This Week' },
        therapeuticCategoryOptions: [{ id: '', option: '' }],
        therapeuticCategoryType: { value: 'is', name: 'is' },
        branchOptions: [{ id: '', option: '' }],
        branchType: { value: 'is', name: 'is' },
        activityFilterOptions: [],
        activityFilterType: { value: 'is', name: 'is' },
        highRisk: false,
        onlyMine: false,
        assignedToMe: false,
        predictiveModelRisk: false,
        dateStart: new Date(dayjs().subtract(1, 'year').subtract(30, 'day')),
        dateEnd: new Date(dayjs().add(1, 'year').add(30, 'day')),
    },
    result: {
        savedFilterResult: [],
        activityCountResult: {},
        workQueueTableHeaders: {},
        workQueueActivityCount: 0,
        workQueueResult: [],
        unassignedPatientResult: [],
        unassignedMedicationResult: [],
    },
    isLoading: true,
    modalState: {
        activityDateModal: defaultActivityDateModalState,
        activityNoteModal: defaultActivityNoteModalState,
    },
    modalMobileAnswersState: {
        mobileAnswersActivityDateModal: defaultActivityDateModalState,
        mobileAnswersActivityNoteModal: defaultActivityNoteModalState,
    },
    selectedRows: {},
    activeSavedFilter: null,
    filterType: FILTER_TYPE.WORK_QUEUE,
    allBranchesList: [],
    allCategoriesList: [],
    allActivityTypesList: [],
    allCustomOptionsList: [],
    allPatientLabelsList: [],
});
